import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { BookmarkParentType } from '~/apollo/generated/v3/graphql';
import { graphql } from '~/apollo/generated/v4';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOItemListV4 } from '~/components/supporting-object/so-item-list-v4';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const STUDY_CROSS_SECTIONS_PAGE = graphql(`
  query StudyCrossSectionsPage($id: ID!) {
    studyGet(id: $id) {
      id
      crossSections {
        ...crossSectionParts
        pictures {
          ...soPictureParts
        }
        files {
          ...fileParts
        }
        georeferences {
          ...georeferenceParts
        }
      }
    }
  }
`);

export default function StudyCrossSectionsRoute() {
  return (
    <ApolloProviderV4>
      <StudyCrossSectionsRouteInner />
    </ApolloProviderV4>
  );
}

function StudyCrossSectionsRouteInner() {
  const studyId = useRouteParam('studyId', parseInt);

  const { data, loading } = useQuery(STUDY_CROSS_SECTIONS_PAGE, {
    variables: { id: studyId },
  });

  const refetchQueries = createRefetchQueries([
    { query: STUDY_CROSS_SECTIONS_PAGE, variables: { id: studyId } },
  ]);

  const crossSections = data?.studyGet?.crossSections ?? [];

  if (loading) return <SpinnerPlaceholder />;

  return (
    <SOItemListV4
      items={crossSections}
      soParentType="study"
      soParentId={studyId}
      bookmarkParentType={BookmarkParentType.CrossSection}
      refetchQueries={refetchQueries}
    />
  );
}
